import {Component, Input, Output, EventEmitter, ViewChild} from '@angular/core';

import {resolveReference, getTypeForSchema} from './util';

declare let window:any;

@Component({
    selector: 'schema-label',
    styles: [`
      .type-choice.dropdown {
        display: inline-block;
        margin-left: 5px;
      }
    `],
    template: `
<label class="monospace">
  <a *ngIf="showRemove" (click)="clickRemove()">
    <i class="fa fa-left fa-times text-danger"></i>
  </a>
  <span>{{label}}</span>
  <span class="text-primary" *ngIf="required">*</span>
  <span>:</span>
  <span class="hl-key" *ngIf="!typeChoices">{{type}}</span>
  <div class="type-choice dropdown" *ngIf="typeChoices">
    <a class="btn btn-xs btn-default dropdown-toggle" data-toggle="dropdown">
      <span>{{type}}</span>
      <i class="fa fa-right fa-caret-down"></i>
    </a>
    <ul class="dropdown-menu">
      <li *ngFor="let t of typeChoices">
        <a (click)="type = t; typeChange.emit(type)">{{t}}</a>
      </li>
    </ul>
  </div>
  <div class="type-choice dropdown" *ngIf="subtypeChoices">
    <a class="btn btn-xs btn-default dropdown-toggle" data-toggle="dropdown">
      <span>{{subtype?.title || 'Choose one'}}</span>
      <i class="fa fa-right fa-caret-down"></i>
    </a>
    <ul class="dropdown-menu">
      <li *ngFor="let t of subtypeChoices">
        <a (click)="subtype = t; expand ? null : toggleExpand(); subtypeChange.emit(t)">{{t.title}}</a>
      </li>
    </ul>
  </div>
  <tooltip-content #descriptionTooltip *ngIf="description">
    <div [innerHtml]="marked(description)"></div>
  </tooltip-content>
  <a *ngIf="description" [tooltip]="descriptionTooltip" tooltipPlacement="right">
    <i class="fa fa-right fa-question-circle"></i>
  </a>
  <a *ngIf="(showExpand && (type === 'object' || type === 'array')) || schema.$ref"
    (click)="toggleExpand()">
    <i class="fa fa-right" [class.fa-plus-square-o]="!expand" [class.fa-minus-square-o]="expand"></i>
  </a>
</label>
<p class="text-danger" *ngIf="!schema">Unknown schema</p>
    `
})
export class SchemaLabelComponent {
  @Input('schema') inputSchema:any;
  schema:any;
  @Input() refBase;
  @Input() label:string;
  @Input() required:boolean;
  @Input() expand:boolean;
  @Input() showRemove:boolean = false;
  @Input() showExpand:boolean;
  @Output() typeChange = new EventEmitter();
  @Output() subtypeChange = new EventEmitter();
  @Output() expandChange = new EventEmitter();
  @Output() schemaChange = new EventEmitter();
  @Output() onRemoved = new EventEmitter();
  @ViewChild('descriptionTooltip') descriptionTooltip;
  type:string;
  typeChoices:string[];
  subtypeChoices:any[];
  subtype: any;
  description:string;
  marked=window.marked;

  constructor() {}

  clickRemove() {
    this.onRemoved.emit();
  }

  ngOnChanges() {
    if (!this.inputSchema) return
    this.setSchema(this.inputSchema);
    if (!this.expand && this.type !== 'array' && this.type !== 'object') this.toggleExpand();
    if (this.expand) this.maybeResolveRef();
  }

  setSchema(schema) {
    if (schema === this.schema) return;
    this.schema = schema;
    let resolved = schema.$ref ? resolveReference(schema.$ref, this.refBase) : schema;
    this.label = this.label || resolved.title;
    this.description = resolved.description;
    this.typeChoices = null;
    let type = getTypeForSchema(resolved, this.refBase);
    if (Array.isArray(type)) {
      if (resolved.type.length > 1) {
        this.typeChoices = resolved.type;
      }
      this.type = type.filter(t => t !== 'null')[0] || type[0];
    } else {
      this.type = type;
    }
    if (this.schema.oneOf || this.schema.anyOf) {
      let choices = (this.schema.oneOf || []).concat(this.schema.anyOf || []);
      this.subtypeChoices = choices.map(s => {
        return s.$ref ? resolveReference(s.$ref, this.refBase) : s;
      });
    }
    this.typeChange.emit(this.type);
    this.schemaChange.emit(this.schema);
  }

  toggleExpand() {
    this.expand = !this.expand;
    this.maybeResolveRef();
    if (!this.expand) {
      this.subtype = null;
      this.subtypeChange.emit(null);
    }
    this.expandChange.emit(this.expand);
  }

  maybeResolveRef() {
    if (!this.schema.$ref) return;
    this.setSchema(resolveReference(this.schema.$ref, this.refBase));
  }
}



// WEBPACK FOOTER //
// ./src/app/json-schema-form/schema-label.component.ts